// extracted by mini-css-extract-plugin
module.exports = {"header":"Settings_header__1YckW","container":"Settings_container__2zz29","rightSection":"Settings_rightSection__2_PbU","content":"Settings_content__1Ogn1"};